/**
 * @generated SignedSource<<d33ad972aa4cabe7c8b0933a646957e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConfirmExpenseInvoiceServicePeriodInput = {
  id: string;
};
export type ExpenseInvoiceServicePeriodConfirmMutation$variables = {
  input: ConfirmExpenseInvoiceServicePeriodInput;
};
export type ExpenseInvoiceServicePeriodConfirmMutation$data = {
  readonly confirmExpenseInvoiceServicePeriod: {
    readonly " $fragmentSpreads": FragmentRefs<"ExpenseInvoiceServicePeriod_invoice">;
  };
};
export type ExpenseInvoiceServicePeriodConfirmMutation = {
  response: ExpenseInvoiceServicePeriodConfirmMutation$data;
  variables: ExpenseInvoiceServicePeriodConfirmMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExpenseInvoiceServicePeriodConfirmMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExpenseInvoice",
        "kind": "LinkedField",
        "name": "confirmExpenseInvoiceServicePeriod",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ExpenseInvoiceServicePeriod_invoice"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExpenseInvoiceServicePeriodConfirmMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExpenseInvoice",
        "kind": "LinkedField",
        "name": "confirmExpenseInvoiceServicePeriod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodSource",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c38ec805bc2872356ca83289e15c74fc",
    "id": null,
    "metadata": {},
    "name": "ExpenseInvoiceServicePeriodConfirmMutation",
    "operationKind": "mutation",
    "text": "mutation ExpenseInvoiceServicePeriodConfirmMutation(\n  $input: ConfirmExpenseInvoiceServicePeriodInput!\n) {\n  confirmExpenseInvoiceServicePeriod(input: $input) {\n    ...ExpenseInvoiceServicePeriod_invoice\n    id\n  }\n}\n\nfragment ExpenseInvoiceServicePeriod_invoice on ExpenseInvoice {\n  id\n  invoiceDate\n  servicePeriodStart\n  servicePeriodEnd\n  servicePeriodSource\n  servicePeriodStatus\n}\n"
  }
};
})();

(node as any).hash = "e9902b3b8ee7eac3dc20a2c0a65333c9";

export default node;
